import React, { useState, useEffect } from 'react';
import FAQSection from './components/FAQSection';
import EquifaxDisclaimersSection from './components/EquifaxDisclaimersSection';
import FooterSection from '../HomePage/components/FooterSection';
import Navigation from '../../components/ui/Navigation';
import LanguageToggle from '../../components/ui/LanguageToggle';

const FAQPage = () => {
  const [currentLanguage, setCurrentLanguage] = useState('EN');

  useEffect(() => {
    const savedLanguage = localStorage.getItem('creditFixerLanguage');
    if (savedLanguage && (savedLanguage === 'EN' || savedLanguage === 'FR')) {
      setCurrentLanguage(savedLanguage);
    }

    const handleLanguageChange = (event) => {
      setCurrentLanguage(event?.detail?.language);
    };

    window.addEventListener('languageChange', handleLanguageChange);
    return () => window.removeEventListener('languageChange', handleLanguageChange);
  }, []);

  const handleLanguageChange = (language) => {
    setCurrentLanguage(language);
  };

  const content = {
    EN: {
      title: "Frequently Asked Questions",
      subtitle: "Everything you need to know about PSPXpress"
    },
    FR: {
      title: "Questions fréquemment posées",
      subtitle: "Tout ce que vous devez savoir sur PSPXpress"
    }
  };

  const text = content?.[currentLanguage] || content?.EN;

  return (
    <div className="min-h-screen bg-background">
      {/* Language Toggle */}
      <div className="fixed top-4 right-4 z-50">
        <LanguageToggle 
          currentLanguage={currentLanguage}
          onLanguageChange={handleLanguageChange}
        />
      </div>

      {/* Navigation */}
      <Navigation currentLanguage={currentLanguage} />

      {/* Hero Section */}
      <section className="pt-32 pb-16 bg-gradient-to-br from-primary to-blue-800">
        <div className="container mx-auto px-6 text-center">
          <h1 className="text-4xl md:text-5xl font-bold text-white mb-6">
            {text?.title}
          </h1>
          <p className="text-xl text-blue-100 max-w-2xl mx-auto">
            {text?.subtitle}
          </p>
        </div>
      </section>

      {/* FAQ Section */}
      <FAQSection currentLanguage={currentLanguage} />

      {/* Equifax Disclaimers */}
      <EquifaxDisclaimersSection currentLanguage={currentLanguage} />

      {/* Footer */}
      <FooterSection currentLanguage={currentLanguage} />
    </div>
  );
};

export default FAQPage;